module.exports = require('./lib/index.js').default;



//////////////////
// WEBPACK FOOTER
// /app/~/angular-ui-block/index.js
// module id = 956
// module chunks = 38